import { writable } from "svelte/store";
import IdentityData from "./IdentityData";

const identity = writable(IdentityData.geollect);

export { identity };
